import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notes"]
  static values = { leadId: Number }
  
  async saveNotes(event) {
    event.preventDefault()
    
    const notes = this.notesTarget.value
    const button = event.currentTarget
    const originalText = button.textContent
    
    button.disabled = true
    button.textContent = 'Saving...'
    
    try {
      const response = await fetch(`/leads/inbox/${this.leadIdValue}/update_notes`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({ notes: notes })
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.showNotification('Notes saved!', 'success')
      } else {
        this.showNotification('Failed to save notes', 'error')
      }
    } catch (error) {
      this.showNotification('Error saving notes', 'error')
    } finally {
      button.disabled = false
      button.textContent = originalText
    }
  }
  
  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
  
  showNotification(message, type) {
    window.dispatchEvent(new CustomEvent('notification:show', {
      detail: { message, type }
    }))
  }
}

